import { useTranslation } from "@/v2/hooks/useTranslation";

export const NewsletterModalMessage = () => {
  const { t } = useTranslation();
  return <span>{t("label.test-newsletter-message")}</span>;
};
